
<app-dashboard-card
	title="Tyalls Audit Summary"
	icon="pi pi-chart-bar"
	[featured]="true"
>
	<div *ngIf="loading" class="dashboard-state">
		Loading audit summary...
	</div>

	<div *ngIf="!loading && error" class="dashboard-state dashboard-state-error">
		Unable to load audit summary.
	</div>

	<div
		*ngIf="!loading && !error && dataStatus === 'WAITING'"
		class="dashboard-state"
	>
		Audit data is still being processed for the selected period.
	</div>

	<div
		*ngIf="!loading && !error && dataStatus === 'UNAVAILABLE'"
		class="dashboard-state"
	>
		Audit data is unavailable for the selected period.
	</div>

	<ng-container
		*ngIf="
			!loading &&
			!error &&
			dataStatus !== 'WAITING' &&
			dataStatus !== 'UNAVAILABLE' &&
			summary
		"
	>
		<div class="audit-table-wrapper">
			<table class="audit-table">
				<thead>
				<tr>
					<th>Risk</th>
					<th>Day</th>
					<th>MTD (AVG)</th>
				</tr>
				</thead>

				<tbody>
				<tr class="audit-financial-row">
					<td>
						<div class="audit-risk-label">
							<span class="audit-risk-indicator audit-risk-financial"></span>
							<span>Total Identified Risk (TIR)</span>
						</div>
					</td>

					<td class="audit-day-value">
						{{ formatCurrency(summary.financialRiskValue) }}
					</td>

					<td>
						{{ formatCurrency(summary.financialRiskMtdAverage) }}
					</td>
				</tr>

				<tr class="audit-residual-financial-row">
					<td>
						<div class="audit-risk-label">
							<span class="audit-risk-indicator audit-risk-residual"></span>
							<span title="Total Identified Risk (TIR) minus Resolved Financial Risk">
									Total Residual Risk (TRR)
								</span>
						</div>
					</td>

					<td
						class="audit-day-value"
						[attr.title]="
								summary.residualFinancialRiskValue === null ||
								summary.residualFinancialRiskValue === undefined
									? 'Residual financial risk unavailable: missing or inconsistent financial attribution'
									: null
							"
					>
						{{ formatResidualCurrency(summary.residualFinancialRiskValue) }}
					</td>

					<td
						[attr.title]="
								summary.residualFinancialRiskMtdAverage === null ||
								summary.residualFinancialRiskMtdAverage === undefined
									? 'MTD residual risk unavailable; attribution may be incomplete or inconsistent'
									: null
							"
					>
						{{ formatResidualCurrency(summary.residualFinancialRiskMtdAverage) }}
					</td>
				</tr>

				<tr class="audit-operations-row">
					<td>
						<div class="audit-risk-label">
							<span class="audit-risk-indicator audit-risk-operations"></span>
							<span>Total Operations Risk</span>
						</div>
					</td>

					<td class="audit-day-value">
						{{ summary.operationsRiskCount | number: '1.0-0' }}
					</td>

					<td>
						{{ formatAverage(summary.operationsRiskMtdAverage) }}
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div
			*ngIf="residualMtdIsIncomplete"
			class="audit-partial-detail"
			role="status"
		>
			Residual financial risk MTD unavailable: validated attribution for
			{{ summary.resolvedFinancialRiskMtdAvailableDayCount }} of
			{{ summary.mtdIncludedDateCount }} eligible days.
		</div>
	</ng-container>

	<div
		*ngIf="
			!loading &&
			!error &&
			dataStatus !== 'WAITING' &&
			dataStatus !== 'UNAVAILABLE' &&
			!summary
		"
		class="dashboard-state"
	>
		Audit data is unavailable for the selected period.
	</div>
</app-dashboard-card>
